export interface LeaveHandover {
  stand_in_name: string
  ticks: string[]
  roster_manager: boolean
  refused_not_full_time: boolean
}

/** The i18n keys of what passes, the roster first; empty means the leave hands over nothing. */
export function handoverRightKeys(handover: LeaveHandover): string[] {
  return [
    ...(handover.roster_manager ? ['leave.handoverRoster'] : []),
    ...handover.ticks.map((kind) => `inventory.register.appoint.kind.${kind}`),
  ]
}

/** Only someone about to approve the leave itself is told what approving passes on. */
export function approvalHandsOver(canDecide: boolean, status: string): boolean {
  return canDecide && status !== 'Cancel Pending'
}

/** A Full Time person may only name a Full Time rep; anyone else's choices are unchanged. */
export function repAllowed(applicantWorkType: string | null | undefined, repWorkType: string | null | undefined): boolean {
  return applicantWorkType !== 'Full Time' || repWorkType === 'Full Time'
}

/** The people a form may offer as rep, keeping the row it already holds so a stored value never reads as empty. */
export function repChoices<T extends { id: string; work_type?: string | null }>(
  people: readonly T[],
  applicantWorkType: string | null | undefined,
  keepId?: unknown,
): T[] {
  return people.filter((p) => p.id === keepId || repAllowed(applicantWorkType, p.work_type))
}
